module.exports = __webpack_public_path__ + "static/media/plane(17).6d4b2659.PNG";